import { RemotePushNotification } from 'data/usecases';
import { PushNotificationUseCaseInterface } from 'domain/usecases';
import { makeApiUrlPushNotification } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makePushNotification = (): PushNotificationUseCaseInterface =>
  new RemotePushNotification(
    makeApiUrlPushNotification(),
    makeAxiosHttpClient(),
  );
